export default __webpack_public_path__ + "static/media/todo_img.55319b2d.png";